import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Integrations } from 'components/Integrations';

export const IntegrationsPage: FC = () => {
	return (
		<Page title="Integrations – EAS Dashboard">
			<Integrations />
		</Page>
	);
};
